import { create } from '@bufbuild/protobuf'

import type { BrandingInfo } from '@jotta/grpc-connect-openapi/config'
import { GetConfigResponseSchema } from '@jotta/grpc-connect-openapi/config'
import { InputFieldVisibility } from '@jotta/grpc-connect-openapi/config'
import { Country } from '@jotta/grpc-connect-openapi/country'
import { Language } from '@jotta/grpc-connect-openapi/language'
import type { PartialMessage } from '@jotta/types/compat'

export const emptyBrandingInfo: PartialMessage<BrandingInfo> = {
  aboutUsLink: '',
  accountTerminationLink: '',
  activeDomain: [],
  activeDomainPostfix: [],
  blogLink: '',
  brandCode: '',
  brandName: '',
  cookiePolicyLink: '',
  customerGroupCode: '',
  customerGroupName: '',
  downloadAndroidLink: '',
  downloadCliLink: '',
  downloadIosLink: '',
  downloadMacLink: '',
  downloadPageLink: '',
  downloadWinLink: '',
  facebookLink: '',
  faqLink: '',
  homepageLink: '',
  cliInstallationInstructionsLink: '',
  partnerInfoLink: '',
  pricingLink: '',
  privacyLink: '',
  signupBusinessLink: '',
  signupFreeLink: '',
  stripePublicKey: '',
  supportLink: '',
  termsLink: '',
  twitterLink: '',
  upgradeLink: '',
  defaultLanguage: Language['UNKNOWN_LANGUAGE'],
  defaultCountry: Country['UNKNOWN_COUNTRY'],
}

export const emptyConfigResponse = create(GetConfigResponseSchema, {
  activeFeatureToggleIds: [],
  activeFeatures: [],
  brandingInfo: emptyBrandingInfo,
  inputFieldsConfig: {
    inputFieldEmail: InputFieldVisibility.ENABLED,
    inputFieldName: InputFieldVisibility.ENABLED,
    inputFieldPhone: InputFieldVisibility.ENABLED,
    inputFieldCountry: InputFieldVisibility.ENABLED,
    inputFieldLanguage: InputFieldVisibility.ENABLED,
  },
})
